module.exports = __webpack_public_path__ + "static/what-is-the-what-5078ad3f5b30df183cced904fa782598.jpg";